import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import {
  getWishs,
  deleteWish,
  getNextWishs,
  getPreviousWishs,
} from "../../store/actions/wishs_action";
import { LIMIT } from "../../domain/constant";
import Pagination from "../../components/common/Pagination";
import Filters from "../../components/common/Filters";
import AddBtn from "../../components/common/AddBtn";
import { SEARCH_TERMS, view_all_table } from "../../shared/enums/wishs_enum";
import DataTable from "../../components/common/DataTable";
const AllWishs = ({
  getWishs,
  deleteWish,
  getNextWishs,
  getPreviousWishs,
  wish: { loading, wishs },
}) => {
  const [page, setPage] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);
  const [q, setQ] = useState(null);
  const [term, setTerm] = useState(null);
  const [termField, setTermField] = useState(SEARCH_TERMS[0]);
  useEffect(() => {
    async function allQuery() {
      if (deleteEntry) {
        await deleteWish(deleteEntry);
      }
      getWishs({});
    }
    allQuery();
  }, [deleteEntry]);

  const nextButtonClicked = () => {
    if (wishs && wishs.length === LIMIT) {
      const lastWish = wishs[wishs.length - 1];
      getNextWishs({ last: lastWish });
      setPage(page + 1);
    }
  };
  const prevBtnClicked = () => {
    if (page > 1) {
      const lastWish = wishs[0];
      getPreviousWishs({
        first: lastWish,
      });
      setPage(page - 1);
    }
  };
  const filterClicked = () => {
    if (term && term.length > 0) {
      setPage(1);
      setQ(term);
      getWishs({ term: term, termField: termField });
    }
  };
  const deleteWishClicked = (id) => {
    setDeleteEntry(id);
  };
  const resetFilter = () => {
    setPage(1);
    setQ(null);
    setTerm("");
    getWishs({});
  };

  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title="Wishs"
          mainLinkTitle="Dashboard"
          mainLinkUrl="/dashboard"
          activeLink="Wish"
        />

        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div
                className="card"
                style={{ boxShadow: "rgb(227 233 243) 0px 4px 22px" }}
              >
                <div className="card-body">
                  <AddBtn item="wishs" title="Wish" />
                  <hr />

                  <Filters
                    q={q}
                    resetFilter={resetFilter}
                    setTerm={setTerm}
                    term={term}
                    filterClicked={filterClicked}
                    termField={termField}
                    setTermField={setTermField}
                    all_terms={SEARCH_TERMS}
                  />
                  <hr />
                  <div>
                    <DataTable
                      keys={view_all_table}
                      data={wishs}
                      field={"wishs"}
                      page={page}
                      deleteBtnClicked={deleteWishClicked}
                      loading={loading}
                    />
                    <Pagination
                      data={wishs}
                      page={page}
                      prevBtnClicked={prevBtnClicked}
                      nextButtonClicked={nextButtonClicked}
                      loading={loading}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ wish: state.wish });

const mapDispatchToProps = {
  getWishs,
  deleteWish,
  getNextWishs,
  getPreviousWishs,
};

export default connect(mapStateToProps, mapDispatchToProps)(AllWishs);
